import api from '@/lib/api';
import { generateFields } from '../generators-api';

/** Mirrors PaymentMovementDto on the backend. Every field is nullable there. */
export interface PaymentMovement {
  paymentId: string | null;
  paidAt: string | null;
  amount: number | null;
  getMatchFee: number | null;
  refundedAmount: number | null;
  refundedAt: string | null;
  email: string | null;
  paymentMethod: string | null;
  tournamentName: string | null;
  registrationPaymentType: string | null;
}

export interface OwnedClub {
  id: string;
  name: string;
  status?: string;
}

const OWNED_CLUB_FIELDS = {
  id: true,
  name: true,
  status: true,
} as const;

export const adminUserDetailApi = {
  // Existing ADMIN-only endpoint that never had a UI.
  getMovements: async (email: string): Promise<PaymentMovement[]> => {
    const response = await api.get('/payments/movements', { params: { email } });
    return response.data;
  },

  getOwnedClubs: async (email: string): Promise<OwnedClub[]> => {
    const response = await api.get(`/clubs/owner/${encodeURIComponent(email)}`, {
      params: { fields: generateFields(OWNED_CLUB_FIELDS) },
    });
    return response.data;
  },
};
